import React, { useEffect } from 'react';
import { SalesPage } from './pages/SalesPage';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    document.title = 'Hábitos Atómicos Espirituales';
    initMetaPixel();
    trackPageView();
  }, []);
  return <SalesPage data-id="element-0" />;
}